import { CandidateFeedbackModalTypes } from '../enums';
import { DefaultActionInfo } from '../types';
import { ReferenceField } from 'features/References';
import { SelectAllListItem } from 'sharedComponents/List/SelectAllListWithRHF';
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined';
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined';
import StarBorderIcon from '@mui/icons-material/StarBorder';

export const actionInfo: DefaultActionInfo[] = [
  {
    tooltipText: CandidateFeedbackModalTypes.SCORECARD,
    icon: <StarBorderIcon />,
  },
  {
    tooltipText: CandidateFeedbackModalTypes.REFERENCE,
    icon: <PersonAddAltOutlinedIcon />,
  },
  {
    tooltipText: CandidateFeedbackModalTypes.APPLICATION,
    icon: <AttachFileOutlinedIcon sx={{ rotate: '45deg' }} />,
  },
];

export const contactOptions: SelectAllListItem[] = [
  {
    label: 'Email',
    id: 0,
  },
  {
    label: 'Phone call',
    id: 1,
  },
  {
    label: 'Virtual interview',
    id: 2,
  },
  {
    label: 'Onsite interview',
    id: 3,
  },
  {
    label: "Haven't spoken with them yet",
    id: 4,
  },
];

export const newReferenceContactFields: ReferenceField[] = [
  {
    fieldName: 'Name',
    isRequired: true,
    placeholder: 'Name',
    formId: 'name',
  },
  {
    fieldName: 'Phone',
    isRequired: true,
    placeholder: 'Phone number',
    formId: 'phone',
    pattern: {
      value: /^\d{10}$/,
      message: 'Invalid phone number format',
    },
  },
  {
    fieldName: 'Email',
    isRequired: true,
    placeholder: 'Email',
    formId: 'email',
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Invalid email address',
    },
  },
  {
    fieldName: 'Job title',
    isRequired: true,
    placeholder: 'Job title',
    formId: 'title',
  },
  {
    fieldName: 'Organization',
    isRequired: true,
    placeholder: 'Organization',
    formId: 'organization',
  },
  {
    fieldName: 'Relationship (e.g. "Supervisor")',
    isRequired: true,
    placeholder: 'Relationship',
    formId: 'relationship',
  },
  {
    fieldName: 'Years known',
    isRequired: true,
    placeholder: 'Years',
    formId: 'years_known',
    pattern: {
      value: /^(0|[1-9]\d*)(\.\d+)?$/,
      message: 'Invalid number format',
    },
  },
];

export const createReferenceFormDefaultValues = {
  name: '',
  phone: '',
  email: '',
  title: '',
  organization: '',
  relationship: null,
  years_known: null,
} as const;
